const heroNew = {
    init() {
        const heroes = document.querySelectorAll('.hero-new');

        if (! heroes.length) {
            return;
        }

        function markLoaded() {
            heroes.forEach(function (hero) {
                hero.classList.add('is-loaded');
            });
        }

        if (document.readyState === 'complete') {
            markLoaded();
        } else {
            window.addEventListener('load', markLoaded);
        }
    }
}

export default heroNew
